<template>
  <v-data-table
    :items="items"
    :headers="headers"
    class="ordera-box-shadow striped-table"
    hide-default-footer
    disable-pagination
  >
    <!-- Redni broj -->
    <template v-slot:item.num="{ index }">
      {{ index + 1 }}
    </template>

    <!-- Prikaz imena jela -->
    <template v-slot:item.name="{ item }">
      <v-tooltip top transition="scale-transition">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">{{ item.name }}</span>
        </template>
        <span class="tooltip-content">ID: {{ item.id }}</span>
      </v-tooltip>
    </template>

    <!-- Prikaz po smenama -->
    <template v-for="shift in selectedShifts" v-slot:[`item.shift_${shift}`]="{ item }">
      <span v-if="item[`shift_${shift}`]">
        <v-tooltip
          v-for="(user, userIndex) in item[`shift_${shift}_users`]"
          top
          transition="scale-transition"
          :key="user.id"
        >
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <strong>{{ user.quantity }}x</strong> {{ toLatin(user.name) }}
              {{ toLatin(user.lastname)
              }}{{ userIndex < item[`shift_${shift}_users`].length - 1 ? ", " : "" }}
            </span>
          </template>
          <span class="tooltip-content">ID: {{ user.id }}</span>
        </v-tooltip>
      </span>
    </template>

    <!-- Ukupno po jelu -->
    <template v-slot:item.total_quantity="{ item }">
      <strong>{{ item.total_quantity }}</strong>
    </template>

    <!-- Footer sa sumama -->
    <template v-slot:body.append>
      <tr class="font-weight-bold">
        <td></td>
        <td>{{ $t("total") }}</td>
        <td v-for="(shiftTotal, index) in shiftTotals" :key="index">{{ shiftTotal }}</td>
        <td class="text-center">
          <strong>{{ grandTotal }}</strong>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    company: { type: Object, required: true },
    selectedShifts: { type: Array, default: () => [1, 2, 3, 4] },
  },
  computed: {
    headers() {
      const headers = [
        { text: this.$t("r_b"), value: "num" },
        { text: this.$t("title"), value: "name" },
      ];
      this.selectedShifts.forEach((shift) => {
        const users = (this.company?.users || []).filter(
          (u) => u.shift === shift + "-smena"
        );
        if (users.length > 0)
          headers.push({ text: this.$t(`shift_${shift}`), value: "shift_" + shift });
      });
      headers.push({ text: this.$t("total"), value: "total_quantity", align: "center" });
      return headers;
    },
    items() {
      return (this.company?.meals || []).map((meal) => {
        let totalQuantity = 0;
        const mealData = { id: meal.id, name: meal.name };
        this.selectedShifts.forEach((shift) => {
          const users = (meal.users[shift + "-smena"] || []).map((u) => {
            totalQuantity += u.quantity;
            return {
              id: u.id,
              name: u.name,
              lastname: u.lastname,
              quantity: u.quantity,
            };
          });
          mealData["shift_" + shift] = users
            .map((u, index) => this.generateUserText(u, index, users))
            .join("");
          mealData["shift_" + shift + "_users"] = users;
        });
        mealData.total_quantity = totalQuantity;
        return mealData;
      });
    },
    shiftTotals() {
      const totals = {};
      this.selectedShifts.forEach((shift) => {
        const users = (this.company?.users || []).filter(
          (u) => u.shift === shift + "-smena"
        );
        if (users.length > 0)
          totals["shift_" + shift] = users.reduce((sum, u) => sum + u.order_count, 0);
      });
      return Object.values(totals);
    },
    grandTotal() {
      return this.shiftTotals.reduce((sum, t) => sum + t, 0);
    },
  },
  methods: {
    generateUserText(user, userIndex, usersList) {
      const quantity = user.quantity;
      const name = this.toLatin(user.name);
      const lastname = this.toLatin(user.lastname);
      const isLast = userIndex >= usersList.length - 1;

      return `<strong>${quantity}x</strong> ${name} ${lastname}${isLast ? "" : ", "}`;
    },
  },
};
</script>
